// Core exports
export { createHttpClient } from "./http";
export type {
  HttpClient,
  HttpClientConfig,
  HttpRequestConfig,
  HttpRequestConfigWithSchema,
  HttpRequestConfigWithHeaders,
  HttpRequestConfigWithSchemaAndHeaders,
  HttpResponse,
} from "./http";
export { HttpError, ValidationError, NetworkError } from "./errors";
export type {
  ApiResponse,
  DataAndMessageResponse,
  MessageResponse,
} from "./types";

// Push type re-exports
export type { VapidPublicKeyResponse } from "./modules/push";

// Module factories
import { createUserModule } from "./modules/user";
import { createPushModule } from "./modules/push";
import { createMemoModule } from "./modules/memo";

import type { HttpClient } from "./http";

export function createApiModules(httpClient: HttpClient) {
  return {
    user: createUserModule(httpClient),
    push: createPushModule(httpClient),
    memo: createMemoModule(httpClient),
  };
}

export type ApiModules = ReturnType<typeof createApiModules>;
